/**
 * Analytics Skeleton Loading
 *
 * Shimmer loading states for cards and charts.
 */

import React from 'react';

const Shimmer: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className = '', style }) => (
  <div className={`animate-pulse bg-gray-200 rounded-lg ${className}`} style={style} />
);

export const StatCardSkeleton: React.FC = () => (
  <div className="bg-white/[0.92] backdrop-blur-md border border-white/20 rounded-2xl p-4 shadow-sm">
    <Shimmer className="h-3 w-16 mb-3" />
    <Shimmer className="h-8 w-20 mb-2" />
    <Shimmer className="h-3 w-12" />
  </div>
);

export const ChartSkeleton: React.FC = () => (
  <div className="bg-white/[0.92] backdrop-blur-md border border-white/20 rounded-2xl p-4 shadow-sm">
    <Shimmer className="h-4 w-32 mb-4" />
    <div className="flex items-end gap-2 h-40">
      {Array.from({ length: 7 }).map((_, i) => (
        <Shimmer
          key={i}
          className="flex-1"
          style={{ height: `${30 + Math.random() * 70}%` }}
        />
      ))}
    </div>
  </div>
);

export const FunnelSkeleton: React.FC = () => (
  <div className="bg-white/[0.92] backdrop-blur-md border border-white/20 rounded-2xl p-4 shadow-sm space-y-3">
    <Shimmer className="h-4 w-40 mb-2" />
    {Array.from({ length: 5 }).map((_, i) => (
      <div key={i} className="flex items-center gap-3">
        <Shimmer className="h-8 flex-1" style={{ maxWidth: `${100 - i * 15}%` }} />
        <Shimmer className="h-4 w-12" />
      </div>
    ))}
  </div>
);

export const AnalyticsSkeleton: React.FC = () => (
  <div className="space-y-4 p-4">
    {/* KPI Cards */}
    <div className="grid grid-cols-2 gap-3">
      <StatCardSkeleton />
      <StatCardSkeleton />
      <StatCardSkeleton />
      <StatCardSkeleton />
    </div>
    {/* Chart */}
    <ChartSkeleton />
    {/* Another chart */}
    <ChartSkeleton />
  </div>
);
